import {
  GIVE_UP_REASON_LIST,
  TASK_STATUS_LIST,
  TASK_COLLECT_LIST,
  LEARN_TASK_STATUS_LIST,
  TASK_IS_TEST_LIST,
  ADV_GENERATION_LIST,
  AGENCY_STRATEGY_STATUS_LIST,
} from './constants/task';
import { BOOL_LIST, FEEDBACK_TYPE_LIST, TASK_SOURCE, K_FRAME_LIST_IN_TASK, IS_INTEREST_TASK } from './constants';
import { getTaskFrame, getIndustryLevel1List, getIndustryList, getOrbacTeams, getTaskProvince, getSpuCategoryList, getShopOpportunityConfig, getUserList, getSelfOpportunityConfig } from '@/pages/agency/task/dashboard/api';
import { getOperatorList } from '@/pages/agency/task/TaskCenter/api';
import { getIndustryInfo } from '@/pages/agency/utils/industry';
import { getTeam } from '@/pages/agency/utils/team';
import { REGEXP } from '@/constants/regexp';
import { SHORTCUTSCONFIG } from '@/constants/reportField';
import TaskCenterService from '@/pages/agency/task/TaskCenter/services';
import { getRainbowCommonConfig } from '@/api/rainbow';

export default {
  task_province_list: {
    name: 'province_list',
    title: '省份',
    type: 'select',
    config: {
      data: [],
      multiple: true,
      clear: true,
      fetchData: getTaskProvince,
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return [
            ...list.map((v: any) => ({
              label: v,
              value: v,
            })),
          ];
        }
        return [];
      },
    },
  },
  task_source: {
    name: 'task_source',
    title: '任务来源',
    type: 'select',
    defaultValue: '',
    config: {
      data: TASK_SOURCE,
    },
    clearable: false,
  },
  is_interest_task: {
    name: 'is_interest_task',
    title: '是否激励任务',
    type: 'select',
    defaultValue: '',
    config: {
      data: IS_INTEREST_TASK,
    },
    clearable: false,
  },
  // 任务看板中使用的 frame
  k_frame_in_task: {
    name: 'k_frame',
    title: 'K框',
    type: 'button-group',
    defaultValue: 'all',
    config: {
      className: 'spaui-button-group-light',
      data: K_FRAME_LIST_IN_TASK,
      fetchData: () => getRainbowCommonConfig('k_frame_config'),
      convertData: (res: any) => {
        return res.task || [];
      },
    },
    clearable: true,
  },
  giveup_reason_list: {
    name: 'giveup_reason_list',
    title: '放弃原因',
    type: 'select',
    config: {
      data: GIVE_UP_REASON_LIST,
      multiple: true,
      clear: true,
    },
  },
  frame_list: {
    name: 'frame_list',
    title: '服务商签框范围',
    type: 'select',
    config: {
      data: [],
      multiple: true,
      clear: true,
      fetchData: getTaskFrame,
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return [
            ...list.map((v: any) => ({
              label: v,
              value: v,
            })),
          ];
        }
        return [];
      },
    },
  },
  industry_level1_list: {
    name: 'industry_level1_list',
    title: '客户行业',
    type: 'select',
    config: {
      data: [],
      multiple: true,
      clear: true,
      fetchData: getIndustryLevel1List,
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return [
            ...list.map((v: any) => ({
              label: v,
              value: v,
            })),
          ];
        }
        return [];
      },
    },
  },
  agency_industry_level1_list: {
    name: 'industry_level1_list',
    title: '客户行业',
    type: 'select',
    config: {
      data: [],
      multiple: true,
      clear: true,
      // 开户行业
      fetchData: () => getIndustryList({ type: 1 }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return [
            ...list
              .filter((v: any) => v.level === 1)
              .map((v: any) => ({
                label: v.name,
                value: v.name,
              })),
          ];
        }
        return [];
      },
    },
  },
  industry_name_list: {
    name: 'industry_name_list',
    title: '客户行业',
    type: 'select-tree',
    config: {
      multiple: true,
      data: [],
      fetchData: () => getIndustryList({ type: 2 }), // kpi行业
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          const { items } = getIndustryInfo(list, { valueKey: 'name', valueWithParent: true });
          return items;
        }
        return [];
      },
    },
  },
  team_id: {
    name: 'team_id',
    title: '部门',
    type: 'select-tree',
    config: {
      data: [],
      fetchData: getOrbacTeams,
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          const { items } = getTeam(list);
          return items;
        }
        return [];
      },
    },
  },
  task_begin_date: {
    name: 'task_begin_date',
    title: '任务开始时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      clear: true,
      type: 'range',
      optionalStartDate: '2022-04-01',
      optionalEndRelativeDays: 365,
    },
    // nameMap: {
    //   start_time: 'begin_date_begin',
    //   end_time: 'begin_date_end',
    // },
  },
  task_end_date: {
    name: 'task_end_date',
    title: '任务结束时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      clear: true,
      type: 'range',
      optionalStartDate: '2022-04-01',
      optionalEndRelativeDays: 365,
    },
    // nameMap: {
    //   start_time: 'end_date_begin',
    //   end_time: 'end_date_end',
    // },
  },
  task_date: {
    name: 'date',
    title: '截止日期',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      longestRange: 365,
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'left',
      optionalEndRelativeDays: 365,
    },
    nameMap: {
      start_time: 'begin_date',
      end_time: 'end_date',
    },
  },
  task_type_list: {
    name: 'task_type_list',
    title: '策略分类',
    type: 'select',
    config: {
      data: [],
      fetchData: () => TaskCenterService.fetchTaskTypeList('operate'),
      multiple: true,
      clear: true,
    },
  },
  agency_task_type_list: {
    name: 'task_type_list',
    title: '策略分类',
    type: 'select',
    config: {
      data: [],
      fetchData: () => TaskCenterService.fetchTaskTypeList('agency_operate'),
      multiple: true,
      clear: true,
    },
  },
  agency_strategy_status_list: {
    name: 'strategy_status_list',
    title: '策略状态',
    type: 'select',
    config: {
      data: AGENCY_STRATEGY_STATUS_LIST,
      checkAll: true,
      multiple: true,
      clear: true,
    },
  },
  is_approach: {
    name: 'is_approach',
    title: '是否临期',
    type: 'select',
    config: {
      data: [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      clear: true,
    },
  },
  learn_task_type_id: {
    name: 'task_type_id',
    title: '任务分类',
    type: 'select',
    config: {
      multiple: true,
      clear: true,
      data: [],
      fetchData: () => TaskCenterService.fetchTaskTypeList('learn'),
    },
  },
  strategy_id_list: {
    name: 'strategy_id_list',
    title: '策略ID',
    type: 'search',
    config: {
      placeholder: '请输入策略ID，用逗号隔开',
    },
    rules: [
      {
        pattern: REGEXP.numArray,
        message: '请输入数字类型，多值使用英文逗号分隔，形如：100或100,101,102',
      },
    ],
  },
  task_title: {
    name: 'task_title',
    title: '任务标题',
    type: 'search',
    config: {
      placeholder: '请输入任务标题',
    },
  },
  task_id: {
    name: 'task_id',
    title: '任务ID',
    type: 'search',
    config: {
      placeholder: '请输入任务ID',
    },
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  task_id_list: {
    name: 'task_id_list',
    title: '任务ID',
    type: 'search',
    config: {
      placeholder: '请输入任务ID，用逗号隔开',
    },
    rules: [
      {
        pattern: REGEXP.numArray,
        message: '请输入数字类型，多值使用英文逗号分隔，形如：100或100,101,102',
      },
    ],
  },
  task_group_id_list: {
    name: 'task_group_id_list',
    title: '任务组ID',
    type: 'search',
    config: {
      placeholder: '请输入任务组ID，用逗号隔开',
    },
    rules: [
      {
        pattern: REGEXP.numArray,
        message: '请输入数字类型，多值使用英文逗号分隔，形如：100或100,101,102',
      },
    ],
  },
  is_test: {
    name: 'is_test',
    title: '是否测试任务',
    type: 'select',
    config: {
      data: TASK_IS_TEST_LIST,
    },
  },
  advertiser_id_list: {
    name: 'advertiser_id_list',
    title: '账户ID',
    type: 'search',
    config: {
      placeholder: '请输入账户ID，用逗号隔开',
    },
    rules: [
      {
        pattern: REGEXP.numArray,
        message: '请输入数字类型，多值使用英文逗号分隔，形如：100或100,101,102',
      },
    ],
  },
  agency_id_list: {
    name: 'agency_id_list',
    title: '所属服务商ID',
    type: 'search',
    config: {
      placeholder: '请输入所属服务商ID，用逗号隔开',
    },
    rules: [
      {
        pattern: REGEXP.numArray,
        message: '请输入数字类型，多值使用英文逗号分隔，形如：100或100,101,102',
      },
    ],
  },
  user_name: {
    name: 'user_name',
    title: '员工姓名',
    type: 'search',
    config: {
      placeholder: '请输入员工姓名',
    },
  },
  user_id_list: {
    name: 'user_id_list',
    title: '员工ID',
    type: 'search',
    config: {
      placeholder: '请输入员工ID，用逗号隔开',
    },
    rules: [
      {
        pattern: REGEXP.numArray,
        message: '请输入数字类型，多值使用英文逗号分隔，形如：100或100,101,102',
      },
    ],
  },
  adv_generation: {
    name: 'adv_generation',
    title: '账户归属',
    type: 'select',
    config: {
      data: ADV_GENERATION_LIST,
      checkAll: true,
      multiple: true,
      clear: true,
    },
  },
  is_read: {
    name: 'is_read',
    title: '是否已读',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  is_giveup: {
    name: 'is_giveup',
    title: '是否放弃',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  feedback_type_list: {
    name: 'feedback_type_list',
    title: '任务反馈',
    type: 'select-tree',
    config: {
      multiple: true,
      data: FEEDBACK_TYPE_LIST,
    },
  },
  is_picked: {
    name: 'is_picked',
    title: '是否选择',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  is_stop: {
    name: 'is_stop',
    title: '是否停投',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  is_transfer_agent: {
    name: 'is_transfer_agent',
    title: '是否季度内转户',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  is_positive: {
    name: 'is_positive',
    title: '是否正向',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  is_delay: {
    name: 'is_delay',
    title: '是否滞后',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  is_done: {
    name: 'is_done',
    title: '是否完成',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  is_auction_ad: {
    name: 'is_auction_ad',
    title: '是否竞价',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  is_nearby: {
    name: 'is_nearby',
    title: '是否附近推',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  is_api: {
    name: 'is_api',
    title: '是否api',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  is_adx: {
    name: 'is_adx',
    title: '是否adx',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  task_status: {
    name: 'status',
    title: '完成情况',
    type: 'select',
    config: {
      data: TASK_STATUS_LIST,
      clear: true,
    },
  },
  learn_task_status: {
    name: 'status',
    title: '完成情况',
    type: 'select',
    config: {
      data: LEARN_TASK_STATUS_LIST,
      clear: true,
    },
  },
  todo_user_list: {
    name: 'todo_user_list',
    title: '待处理人',
    type: 'select',
    config: {
      multiple: true,
      clear: true,
      fetchData: getOperatorList,
      convertData: (res: any) => {
        return res?.data?.list?.map((v: any) => ({ label: v.operator_name, value: v.user_id })) || [];
      },
    },
  },
  operator_list: {
    name: 'operator_list',
    title: '处理人',
    type: 'select',
    config: {
      multiple: true,
      clear: true,
      fetchData: getOperatorList,
      convertData: (res: any) => {
        return res?.data?.list?.map((v: any) => ({ label: v.operator_name, value: v.user_id })) || [];
      },
    },
  },
  task_operation_date: {
    name: 'operation_date',
    title: '处理时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      clear: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      timePicker: true,
      format: 'xxxx-xx-xx xx:xx:xx',
    },
    nameMap: {
      start_time: 'operation_date_begin',
      end_time: 'operation_date_end',
    },
  },
  collect_task_status: {
    name: 'collect_task_status',
    title: '是否收藏',
    type: 'select',
    config: {
      data: TASK_COLLECT_LIST,
      clear: true,
    },
  },
  filter_expire_task: {
    name: 'filter_expire_task',
    title: '是否过滤已结束任务',
    type: 'select',
    defaultValue: 1,
    config: {
      data: BOOL_LIST,
      clear: true,
    },
  },
  is_orbac_card: {
    name: 'is_orbac',
    title: '数据范围',
    type: 'button-group',
    defaultValue: 0,
    config: {
      theme: 'light',
      data: [
        { value: 0, label: '角色' },
        { value: 1, label: '组织架构' },
      ],
    },
  },
  is_orbac: {
    name: 'is_orbac',
    title: '数据范围',
    type: 'select',
    config: {
      data: [
        { value: 0, label: '角色' },
        { value: 1, label: '组织架构' },
      ],
    },
  },
  agency_type_list: {
    name: 'agency_type_list',
    title: '任务源',
    type: 'select',
    defaultValue: 0,
    config: {
      data: [
        { value: 0, label: '公有库' },
        { value: 1, label: '私有库' },
      ],
    },
    clearable: false,
  },
  /// 商品
  spuids: {
    name: 'spuids',
    title: 'SPU ID',
    type: 'search',
    config: {
      placeholder: '多个值用逗号隔开',
    },
    rules: [
      {
        pattern: REGEXP.numArray,
        message: '请输入数字类型，多值使用英文逗号分隔，形如：100或100,101,102',
      },
    ],
  },
  k_frame_spu: {
    name: 'frame_area',
    title: 'K框',
    type: 'button-group',
    defaultValue: 'k1_frame',
    config: {
      className: 'spaui-button-group-light',
      fetchData: () => getRainbowCommonConfig('k_frame_config'),
      convertData: (res: any) => {
        return res.task_spu || [];
      },
    },
    clearable: true,
  },
  white_brand_mark: {
    name: 'white_brand_mark',
    title: '品牌属性',
    type: 'select',
    config: {
      data: [
        { value: 2, label: '品牌' },
        { value: 1, label: '白牌' },
      ],
      clear: true,
    },
    clearable: true,
  },
  new_spu_flag: {
    name: 'new_spu_flag',
    title: '新老品',
    type: 'select',
    config: {
      data: [
        { value: 1, label: '新品' },
        { value: 2, label: '老品' },
      ],
      clear: true,
    },
    clearable: true,
  },
  source: {
    name: 'source',
    title: '是否运营推荐',
    type: 'select',
    config: {
      data: [
        { value: 1, label: '是' },
        { value: 2, label: '否' },
      ],
      clear: true,
    },
    clearable: true,
  },
  spu_type: {
    name: 'spu_type',
    title: '是否正式SPU',
    type: 'select',
    config: {
      data: [
        { value: 1, label: '是' },
        { value: 2, label: '否' },
      ],
      clear: true,
    },
    clearable: true,
  },
  is_import: {
    name: 'is_import',
    title: '是否引入',
    type: 'select',
    config: {
      data: [
        { value: 1, label: '是' },
        { value: 0, label: '否' },
      ],
      clear: true,
    },
    clearable: true,
  },
  is_new_brand: {
    name: 'is_new_brand',
    title: '是否市场新品',
    type: 'select',
    config: {
      data: [
        { value: 1, label: '是' },
        { value: 2, label: '否' },
      ],
      clear: true,
    },
    clearable: true,
  },
  spu_category: {
    name: 'spu_category',
    title: '商品类目',
    type: 'select-tree',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      search: true,
      fetchData: getSpuCategoryList,
      convertData: (res: any) => convertSpuCategoryList(res.data),
    },
  },
  mark_time: {
    name: 'mark_time',
    title: '下发时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      longestRange: 93, // 最大查询一个季度
      clear: false,
    },
    nameMap: {
      start_time: 'start_date',
      end_time: 'end_date',
    },
    clearable: false,
  },
  adp_version: {
    name: 'adp_version',
    title: '投放端版本',
    type: 'select',
    defaultValue: '',
    config: {
      data: [],
    },
    clearable: true,
  },
  opportunity_status: {
    name: 'opportunity_status',
    title: '机会状态',
    type: 'select',
    config: {
      clear: true,
      data: [],
    },
    clearable: true,
  },
  priority: {
    name: 'priority',
    title: '建议优先级',
    type: 'select',
    config: {
      clear: true,
      data: [],
    },
    clearable: true,
  },
  shop_industry: {
    name: 'industry_filter_list',
    title: 'KPI行业',
    type: 'select-tree',
    config: {
      clear: true,
      multiple: true,
      data: [],
      fetchData: getShopOpportunityConfig,
      convertData: (res: any) => {
        const data = res?.data?.kpi_industry_list || {};
        return Object.keys(data).map((level1: string) => {
          return {
            value: level1,
            desc: level1,
            options: data[level1]?.map((level2: string) => ({
              value: `${level1}_${level2}`,
              desc: level2,
            })) || [],
          };
        });
      },
    },
  },
  shop_category: {
    name: 'main_category_filter_list',
    title: '主营类目',
    type: 'select-tree',
    config: {
      clear: true,
      multiple: true,
      data: [],
      fetchData: getShopOpportunityConfig,
      convertData: (res: any) => {
        const data = res?.data?.main_category_list || {};
        return Object.keys(data).map((level1: string) => {
          return {
            value: level1,
            desc: level1,
            options: data[level1]?.map((level2: string) => ({
              value: `${level1}_${level2}`,
              desc: level2,
            })) || [],
          };
        });
      },
    },
  },
  account_online: {
    name: 'account_online',
    title: '是否开户',
    type: 'select',
    config: {
      clear: true,
      data: [],
    },
    clearable: true,
  },
  is_distribution: {
    name: 'is_distribution',
    title: '是否分配',
    type: 'select',
    config: {
      clear: true,
      data: [
        { value: 1, label: '已分配' },
        { value: 0, label: '未分配' },
      ],
    },
    clearable: true,
  },
  shop_type_list: {
    name: 'shop_type_list',
    title: '客户类型',
    type: 'select',
    defaultValue: [],
    config: {
      clear: true,
      multiple: true,
      data: [],
    },
    clearable: true,
  },
  follower_user_id: {
    title: '跟进人',
    name: 'follower_user_id',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '请选择跟进人',
      fetchData: (params: any) => getUserList({
        ...params || {},
        page: 1,
        page_size: 20,
      }),
      convertData: (res: any) => {
        return res?.data || [];
      },
      search: true,
      getSearchParams: (keyword: any) => ({ keyword }),
    },
  },
  followup_status: {
    name: 'followup_status',
    title: '跟进状态',
    type: 'button-group',
    defaultValue: 'all',
    config: {
      className: 'spaui-button-group-light',
      data: [],
    },
  },
  is_open_shop: {
    name: 'is_open_shop',
    title: '是否已开店',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
      placeholder: '请选择',
    },
  },
  is_open_account: {
    name: 'is_open_account',
    title: '是否已开户',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
      placeholder: '请选择',
    },
  },
  is_standard_new_account: {
    name: 'is_standard_new_account',
    title: '是否达标新客',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
      placeholder: '请选择',
    },
  },
  is_standard_new_valid_account: {
    name: 'is_standard_new_valid_account',
    title: '是否达标有效新客',
    type: 'select',
    config: {
      data: BOOL_LIST,
      clear: true,
      placeholder: '请选择',
    },
  },
  self_kpi_industry: {
    name: 'industry_filter_list',
    title: 'KPI行业',
    type: 'select-tree',
    config: {
      clear: true,
      multiple: true,
      data: [],
      fetchData: getSelfOpportunityConfig,
      convertData: (res: any) => {
        const data = res?.data?.kpi_industry_list || {};
        return Object.keys(data).map((level1: string) => {
          return {
            value: level1,
            desc: level1,
            options: data[level1]?.map((level2: string) => ({
              value: `${level1}_${level2}`,
              desc: level2,
            })) || [],
          };
        });
      },
    },
  },
  team_type: {
    name: 'team_type',
    title: '战队类型',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '请选择',
    },
  },
  belong_team: {
    name: 'belong_team',
    title: '所属拓客战队',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '请选择',
    },
  },
  is_targeted_list: {
    name: 'is_targeted_list',
    title: '是否行业靶向名单',
    type: 'select',
    config: {
      data: [
        { label: '是', value: '是' },
        { label: '否', value: '否' },
      ],
      clear: true,
      placeholder: '请选择',
    },
  },
  created_at: {
    name: 'created_at',
    title: '首次录入时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      clear: true,
      type: 'range',
      placeholder: '请选择',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
    },
  },
  updated_at: {
    name: 'updated_at',
    title: '最新更新时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      clear: true,
      type: 'range',
      placeholder: '请选择',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
    },
  },
  customer_name: {
    name: 'customer_name',
    title: '客户主体名称',
    type: 'search',
    config: {
      placeholder: '请输入',
    },
  },
  customer_source: {
    name: 'customer_source',
    title: '客户来源',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '请选择',
    },
  },
  customer_wx_shop_name: {
    name: 'customer_wx_shop_name',
    title: '客户主体名称',
    type: 'search',
    config: {
      placeholder: '请输入',
    },
  },
  product_name: {
    name: 'product_name',
    title: '品牌名称',
    type: 'search',
    config: {
      placeholder: '请输入',
    },
  },
  sales_name: {
    name: 'sales_name',
    title: '行业直客销售姓名',
    type: 'search',
    config: {
      placeholder: '请输入',
    },
  },
};

// 转换商品类目到 SelectTree 的数据结构
export function convertSpuCategoryList(data: any[] = [], deep = 1): any {
  return data.map((item) => {
    return {
      value: `${deep}__${item.id}`,
      desc: item.name,
      options: convertSpuCategoryList(item.children, deep + 1),
    };
  });
}
